import { render } from "./ShipmentCenter.vue?vue&type=template&id=d62344aa&scoped=true"
import script from "./ShipmentCenter.vue?vue&type=script&lang=js"
export * from "./ShipmentCenter.vue?vue&type=script&lang=js"

import "./ShipmentCenter.vue?vue&type=style&index=0&id=d62344aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62344aa"]])

export default __exports__